(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5615],{

/***/ 655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]",
      function () {
        return __webpack_require__(78939);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 53593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82010);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63189);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93024);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);







// import * as Dialog from '@radix-ui/react-dialog';
// import { Cross2Icon } from '@radix-ui/react-icons';
const SectionTitle = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return _jsx(Text, {
        style: "subtitle1",
        css: {
            color: "$gray12",
            mb: 8
        },
        children: title
    });
};
const SectionLink = (param)=>/*#__PURE__*/ {
    let { name , href  } = param;
    return _jsx(Anchor, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        weight: "medium",
        css: {
            fontSize: 14,
            mt: 5
        },
        children: name
    });
};
const developerSectionLinks = [
    {
        name: "Copyright",
        href: "copyright"
    },
    {
        name: "Privacy Policy",
        href: "privacypolicy"
    }
];
const companySectionLinks = [
    {
        name: "Jobs",
        href: "#"
    },
    {
        name: "Terms of Use",
        href: "#"
    },
    {
        name: "Privacy Policy",
        href: "#"
    }
];
const Footer = ()=>{
    const { theme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        justify: "between",
        className: "footer",
        css: {
            borderTop: "1px solid $gray7",
            borderStyle: "solid",
            pt: "$5",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 36,
            "@bp600": {
                flexDirection: "row",
                gap: 0,
                height: "100%",
                "@bp800": {
                    px: "$5"
                },
                "@xl": {
                    px: "$6"
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                css: {
                    gap: 80,
                    "@bp600": {
                        gap: 136
                    }
                },
                children: theme == "dark" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    css: {
                        gap: "$4"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://t.me/BlueBitLTD",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faTelegram */ .Uv8,
                                    width: 14,
                                    height: 14
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://twitter.com/Bluebit_io",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faTwitter */ .mdU,
                                    width: 14,
                                    height: 14
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://instagram.com/bluebit.io?igshid=NGVhN2U2NjQ0Yg==",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faInstagram */ .Zzi,
                                    width: 14,
                                    height: 14
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                    className: "whitetheme",
                    css: {
                        gap: "$4"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://t.me/BlueBitLTD",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faTelegram */ .Uv8,
                                    width: 14,
                                    height: 14
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://twitter.com/Bluebit_io",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faTwitter */ .mdU,
                                    width: 14,
                                    height: 14
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "#https://instagram.com/bluebit.io?igshid=NGVhN2U2NjQ0Yg==",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                size: "xs",
                                color: "gray3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faInstagram */ .Zzi,
                                    width: 14,
                                    height: 14
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "link colorlink1",
                href: "/",
                children: "\xa9 2024 Bluevinci.io"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    alignItems: "flex-start",
                    "@bp600": {
                        alignItems: "flex-end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        justify: "between",
                        css: {
                            flexDirection: "column",
                            alignItems: "flex-start",
                            "@bp600": {
                                flexDirection: "row",
                                gap: 40
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                css: {
                                    "@bp600": {
                                        gap: 10
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                    direction: "column"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                                direction: "column",
                                css: {
                                    alignItems: "flex-start",
                                    "@bp600": {
                                        alignItems: "flex-end"
                                    }
                                },
                                children: theme ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: theme == "dark" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/logobv.png",
                                        width: 120,
                                        height: 70,
                                        alt: theme
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: "/bvincilogow.png",
                                        width: 120,
                                        height: 70,
                                        alt: "not defind"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        css: {
                            gap: "$4",
                            mt: 16
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 48126:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const OBJECT_VAL = [];
OBJECT_VAL["1"] = "ethereum";
OBJECT_VAL["42161"] = "arbitrum";
OBJECT_VAL["5"] = "goerli";
OBJECT_VAL["137"] = "polygon";
OBJECT_VAL["80001"] = "mumbai";
OBJECT_VAL["56"] = "bsc";
OBJECT_VAL["7777777"] = "zora";
OBJECT_VAL["420"] = "optimism";
OBJECT_VAL["10"] = "optimism";
OBJECT_VAL["11155111"] = "sepolia";
OBJECT_VAL["8453"] = "base";
OBJECT_VAL["43114"] = "avalanche";
OBJECT_VAL["42170"] = "arbitrum-nova";
/* harmony default export */ __webpack_exports__["Z"] = (OBJECT_VAL);


/***/ }),

/***/ 45708:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const OBJECT_VAL = [];
OBJECT_VAL["1"] = "https://etherscan.io";
OBJECT_VAL["42161"] = "https://arbiscan.io";
OBJECT_VAL["5"] = "https://goerli.etherscan.io";
OBJECT_VAL["80001"] = "https://mumbai.polygonscan.com";
OBJECT_VAL["56"] = "https://bscscan.com";
OBJECT_VAL["137"] = "https://polygonscan.com";
OBJECT_VAL["7777777"] = "https://explorer.zora.energy";
OBJECT_VAL["420"] = "https://optimistic.etherscan.io";
OBJECT_VAL["10"] = "https://optimistic.etherscan.io";
OBJECT_VAL["11155111"] = "https://sepolia.etherscan.io";
OBJECT_VAL["8453"] = "https://basescan.org";
OBJECT_VAL["43114"] = "https://avascan.info";
OBJECT_VAL["42170"] = "https://nova.arbiscan.io";
/* harmony default export */ __webpack_exports__["Z"] = (OBJECT_VAL);


/***/ }),

/***/ 48377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "db": function() { return /* binding */ db; }
/* harmony export */ });
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39828);
// Import the functions you need from the SDKs you need


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCi2jevScs8nEiLaHHfm22poj0ld",
    authDomain: "bv2a-37d51.firebaseapp.com",
    databaseURL: "https://bv2a-37d51-default-rtdb.firebaseio.com",
    projectId: "bv2a-37d51",
    storageBucket: "bv2a-37d51.appspot.com",
    messagingSenderId: "852061388684",
    appId: "1:852061388684:web:cde8fd2bccdc396032a0a9"
};
const app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig);
//@ts-ignore
// firebase.firestore().settings({ experimentalForceLongPolling: true }); //add this..
// export const db = firebase.firestore();
const db = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_1__/* .getFirestore */ .ad)();


/***/ }),

/***/ 84137:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const OBJECT_VAL = [];
OBJECT_VAL["1"] = "https://api.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["42161"] = "https://api-arbitrum.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["5"] = "https://api-goerli.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["137"] = "https://api-polygon.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["80001"] = "https://api-mumbai.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["56"] = "https://api-bsc.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["7777777"] = "https://api-zora.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["420"] = "https://api-optimism.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["10"] = "https://api-optimism.reservoir.tools/collections/trending-mints/v1";
OBJECT_VAL["8453"] = "https://api-optimism.reservoir.tools/collections/trending-mints/v1";
/* harmony default export */ __webpack_exports__["Z"] = (OBJECT_VAL);


/***/ }),

/***/ 84023:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const OBJECT_VAL = [];
OBJECT_VAL["1"] = " Ethereum";
OBJECT_VAL["42161"] = " Arbitrum One";
OBJECT_VAL["5"] = " Goerli";
OBJECT_VAL["80001"] = " Mumbai";
OBJECT_VAL["56"] = " BNB Smart Chain";
OBJECT_VAL["137"] = " Polygon";
OBJECT_VAL["7777777"] = " Zora";
OBJECT_VAL["420"] = " Optimism";
OBJECT_VAL["10"] = " Optimism";
OBJECT_VAL["11155111"] = " Sepolia";
OBJECT_VAL["8453"] = " Base";
OBJECT_VAL["43114"] = " Avalanche";
OBJECT_VAL["42170"] = " Nova Arbitrum";
/* harmony default export */ __webpack_exports__["Z"] = (OBJECT_VAL);


/***/ }),

/***/ 39866:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const OBJECT_VAL = [];
OBJECT_VAL["1"] = "512.png";
OBJECT_VAL["42161"] = "arbitrum.png";
OBJECT_VAL["5"] = "512.png";
OBJECT_VAL["80001"] = "polygon.png";
OBJECT_VAL["56"] = "bnb.png";
OBJECT_VAL["137"] = "polygon.png";
OBJECT_VAL["7777777"] = "CoreZorb.svg";
OBJECT_VAL["420"] = "optimism.svg";
OBJECT_VAL["10"] = "optimism.svg";
OBJECT_VAL["11155111"] = "sapolia.png";
OBJECT_VAL["8453"] = "base.svg";
OBJECT_VAL["43114"] = "icons/avalanche-icon-dark.svg";
OBJECT_VAL["42170"] = "icons/arbitrum-nova-icon-dark.svg";
/* harmony default export */ __webpack_exports__["Z"] = (OBJECT_VAL);


/***/ }),

/***/ 78939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63189);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48053);
/* harmony import */ var components_primitives_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68916);
/* harmony import */ var ag_grid_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47009);
/* harmony import */ var ag_grid_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(ag_grid_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_home_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53593);
/* harmony import */ var ag_grid_community_styles_ag_grid_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14546);
/* harmony import */ var ag_grid_community_styles_ag_grid_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(ag_grid_community_styles_ag_grid_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var ag_grid_community_styles_ag_theme_alpine_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51204);
/* harmony import */ var ag_grid_community_styles_ag_theme_alpine_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(ag_grid_community_styles_ag_theme_alpine_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var ag_grid_community_styles_ag_theme_quartz_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54853);
/* harmony import */ var ag_grid_community_styles_ag_theme_quartz_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(ag_grid_community_styles_ag_theme_quartz_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _config_firebase__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48377);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39828);
/* harmony import */ var _config_variableImage__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(39866);
/* harmony import */ var _config_variableCommon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84023);
/* harmony import */ var _config_chainURL__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45708);
/* harmony import */ var _config_chainInternalURL__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48126);
/* harmony import */ var _config_mintURL__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84137);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_18__);













//@ts-ignore

//@ts-ignore

//@ts-ignore

//@ts-ignore

//@ts-ignore
//@ts-ignore


const IndexPage = ()=>{
    //@ts-ignore
    const imagesMain = _config_variableImage__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z;
    //@ts-ignore
    const urlMain = _config_chainURL__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
    //@ts-ignore
    const InternalurlMain = _config_chainInternalURL__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z;
    //@ts-ignore
    const getchainName = _config_variableCommon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z;
    //@ts-ignore
    const getmintURL = _config_mintURL__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z;
    //@ts-ignore
    const OBJECT_VALm = _config_variableCommon__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z;
    //  //@ts-ignore
    // const OBJECT_VAL:any[] = OBJECT_VAL;
    const { theme: nextTheme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_9__/* .useTheme */ .F)();
    const [theme, setTheme] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (nextTheme) {
            setTheme(nextTheme);
        }
    }, [
        nextTheme
    ]);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("null");
    const [countries, setCountries] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [mintsCustom, setMintsCustom] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [mintsCollection, setMintsCollection] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [mintsCustomTest, setMintsCustomTest] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [toshow, setToshow] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [toshow1, setToshow1] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [toshowFree, settoshowFree] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [fc, setFs] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [fc1, setFs1] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    let [empty, setemptycount] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(0);
    const [myCarChain, setMyCarChain] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("all");
    ///////////////////////////////////start firebase ///////////
    let [rowDataold, setRowDataold] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]); // Set rowData to Array of Objects, one Object per Row
    let [rowData, setRowData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]); // Set rowData to Array of Objects, one Object per Row
    const [data, setData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(null);
    //@ts-ignore
    const [dogs, setDogs] = react__WEBPACK_IMPORTED_MODULE_10__.useState([]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        // , where("mintType", "==", 'paid') 
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoTopTrendingMints"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .limit */ .b9)(10));
        //  let dogsCol = collection(db, 'autoTopTrendingMints');
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log('dogsArray1',dogsArray);
            //  setFs(dogsArray)     
            // setRowData(dogsArray)
            dogsArray.sort((a, b)=>parseFloat(b.sixHourCount) - parseFloat(a.sixHourCount));
            setRowData(dogsArray);
            setRowDataold(dogsArray);
        // console.log('dogsArrayaftershort',dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        // , where("mintType", "==", 'paid') 
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoTopTrendingMints"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("mintType", "==", "free"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .limit */ .b9)(16));
        //  let dogsCol = collection(db, 'autoTopTrendingMints');
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log('dogsArray1',dogsArray);
            //  setFs(dogsArray)     
            // setRowData(dogsArray)
            dogsArray.sort((a, b)=>parseFloat(b.sixHourCount) - parseFloat(a.sixHourCount));
            settoshowFree(dogsArray);
        // console.log('dogsArrayaftershort',dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "top"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log(dogsArray); 
            for(let index = 0; index < dogsArray.length; index++){
                let element = dogsArray[index];
            // console.log('element', element);
            // dogsArray[index].totalMints = 5;
            }
            setToshow(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    const [topfreedrops, setTopFreeDrops] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "topfreedrops"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log(dogsArray); 
            for(let index = 0; index < dogsArray.length; index++){
                let element = dogsArray[index];
            // console.log('element', element);
            // dogsArray[index].totalMints = 5;
            }
            setTopFreeDrops(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    const [featureddrops, setFeaturedDrop] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "featureddrops"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log(dogsArray); 
            for(let index = 0; index < dogsArray.length; index++){
                let element = dogsArray[index];
            // console.log('element', element);
            // dogsArray[index].totalMints = 5;
            }
            setFeaturedDrop(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    const [featuredcollections, setFeaturedcollections] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "featuredcollections"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log(dogsArray); 
            for(let index = 0; index < dogsArray.length; index++){
                let element = dogsArray[index];
            // console.log('element', element);
            // dogsArray[index].totalMints = 5;
            }
            setFeaturedcollections(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    ////////////////////////testing/////////////
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{}, []);
    //////////////////testinend/////////////////
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "f_mints"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
        // console.log(dogsArray);
        //  setMintsCollection(dogsArray);
        //  setRowData(dogsArray);
        // setMintsCustom(dogsArray);
        // setToshow(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        //  let dogsCol = collection(db, 'autoManualFeatureCollections');
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "autoManualFeatureCollections"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .where */ .ar)("key", "==", "fc"));
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
            // console.log(dogsArray);
            dogsArray.sort((a, b)=>parseFloat(b.h24v) - parseFloat(a.h24v));
            // setRowData(dogsArray)
            // setMintsCustom(dogsArray);
            setFs(dogsArray);
            setFs1(dogsArray);
        });
        return ()=>unSubscribe();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        // , where("mintType", "==", 'paid') 
        const dogsCol = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .collection */ .hJ)(_config_firebase__WEBPACK_IMPORTED_MODULE_11__.db, "nftscan"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .limit */ .b9)(100));
        //  let dogsCol = collection(db, 'autoTopTrendingMints');
        const unSubscribe = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_12__/* .onSnapshot */ .cf)(dogsCol, (dogsSnap)=>{
            const dogsArray = dogsSnap.docs.map((dogSnap)=>{
                //@ts-ignore
                const dog = dogSnap.data();
                dog.id = dogSnap.id;
                return dog;
            });
        });
        return ()=>unSubscribe();
    }, []);
    const gridRef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)();
    // This is a plain JS (not React) component
    class DeltaIndicator {
        init(params) {
            // console.log('paramssss',params)
            const element = document.createElement("span");
            const element1 = document.createElement("a");
            const imageElement = document.createElement("img");
            // console.log('params.data.image',params.data.image)
            if (params.data.image) {
                imageElement.src = params.data.image;
            } else {
                imageElement.src = "https://iconicentertainment.in/wp-content/uploads/2013/11/dummy-image-square.jpg";
            }
            element1.href = "working";
            // element.appendChild(element1);
            element.appendChild(imageElement);
            // element.appendChild(imageElement);
            // element.appendChild(document.createTextNode(params.data.name));
            var link = document.createElement("a");
            link.setAttribute("target", "_blank");
            var _params_data_chain;
            //@ts-ignore
            link.href = "/".concat(InternalurlMain[(_params_data_chain = params.data.chain) !== null && _params_data_chain !== void 0 ? _params_data_chain : "1"], "/collection/").concat(params.data.address);
            link.innerText = params.data.name;
            element.appendChild(link);
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // This is a plain JS (not React) component
    class twinty4mintHandle {
        init(params) {
            // console.log('paramssss',params)
            const element = document.createElement("span");
            const imageElement = document.createElement("img");
            if (params.data.oneHourCount > 0) {
                imageElement.src = "arrow/green1.png";
            } else {
                imageElement.src = "arrow/red1.png";
            }
            element.appendChild(imageElement);
            element.appendChild(document.createTextNode(params.data.oneHourCount));
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // This is a plain JS (not React) component
    class sixHourCount {
        init(params) {
            // console.log('paramssss',params)
            const element = document.createElement("span");
            const imageElement = document.createElement("img");
            element.appendChild(document.createTextNode(params.data.sixHourCount));
            if (params.data.sixHourCount > 999) {
                imageElement.src = "arrow/hot1.png";
                element.appendChild(imageElement);
            } else {
            //
            }
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // This is a plain JS (not React) component
    class h24v {
        init(params) {
            // console.log('paramssss',params)
            const element = document.createElement("span");
            const imageElement = document.createElement("img");
            if (params.data.h24v > 0) {
                imageElement.src = "arrow/green1.png";
            } else {
                imageElement.src = "arrow/red1.png";
            }
            element.appendChild(imageElement);
            element.appendChild(document.createTextNode(params.data.h24v));
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // This is a plain JS (not React) component
    class chainHandle {
        init(params) {
            // console.log('paramssss',params)
            const element = document.createElement("span");
            const element1 = document.createElement("a");
            const imageElement = document.createElement("img");
            // console.log('params.data.image',params.data.image)
            if (imagesMain[params.data.chain]) {
                imageElement.src = imagesMain[params.data.chain];
            } else {
                imageElement.src = imagesMain["1"];
            }
            element1.href = "working";
            // element.appendChild(element1);
            element.appendChild(imageElement);
            // element.appendChild(imageElement);
            // element.appendChild(document.createTextNode(params.data.name));
            var link = document.createElement("a");
            link.setAttribute("target", "_blank");
            var _params_data_chain;
            //@ts-ignore
            // link.target = "_blank";
            link.href = "".concat(urlMain[(_params_data_chain = params.data.chain) !== null && _params_data_chain !== void 0 ? _params_data_chain : "1"], "/address/").concat(params.data.address);
            link.innerText = OBJECT_VALm[params.data.chain];
            element.appendChild(link);
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // This is a plain JS (not React) component
    class mintprice {
        init(params) {
            const element = document.createElement("span");
            const imageElement = document.createElement("img");
            if (params.data.chain == 1) {
                imageElement.src = imagesMain[params.data.chain];
            } else {
                imageElement.src = imagesMain[params.data.chain];
            }
            // element.appendChild(imageElement);
            if (params.data.price) {
                // let v:any = params.data.price/(1*1000000000000000000)
                let v = params.data.price;
                v = v + " " + params.data.symbol;
                element.appendChild(document.createTextNode(v));
            } else {
                let m = 0;
                // m = m + " " + params.data.symbol
                element.appendChild(document.createTextNode(m));
            }
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    class fprice {
        init(params) {
            var _params_data_fprice, _params_data_fprice_amount;
            const element = document.createElement("span");
            const imageElement = document.createElement("img");
            if (params.data.chain == 1) {
                imageElement.src = imagesMain[params.data.chain];
            } else {
                imageElement.src = imagesMain[params.data.chain];
            }
            // element.appendChild(imageElement);
            if ((_params_data_fprice = params === null || params === void 0 ? void 0 : params.data.fprice) === null || _params_data_fprice === void 0 ? void 0 : (_params_data_fprice_amount = _params_data_fprice.amount) === null || _params_data_fprice_amount === void 0 ? void 0 : _params_data_fprice_amount.decimal) {
                let v = params.data.price / (1 * 1000000000000000000);
                //  v= parseFloat(v.toFixed(5))
                v = params === null || params === void 0 ? void 0 : params.data.fprice.amount.decimal;
                v = v + " " + params.data.symbol;
                element.appendChild(document.createTextNode(v));
            // console.log('params?.data?.fprice',params?.data.fprice.amount.decimal)
            } else {
                let m = 0;
                // m = m + " " + params.data.symbol
                element.appendChild(document.createTextNode(m));
            }
            this.eGui = element;
        }
        getGui() {
            return this.eGui;
        }
    }
    // Each Column Definition results in one Column.
    const [columnDefs2, setColumnDefs2] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([
        {
            headerName: "Collection",
            cellRenderer: DeltaIndicator,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1",
                        textAlign: "center"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1",
                        textAlign: "center"
                    };
                }
            }
        },
        {
            headerName: "Chain",
            // unSortIcon: true,
            cellRenderer: chainHandle,
            filter: false,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage"
            ]
        },
        {
            headerName: "Minting Price",
            // unSortIcon: true,
            cellRenderer: mintprice,
            filter: false,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage"
            ]
        },
        // {headerName: 'Minting Price',unSortIcon: true,shorting:true, field: 'price',cellStyle: function(params:any) {
        //             if (params.node.sixHourMint=='Police') {
        //                 return {color: 'red1'};
        //             } else {
        //                 // return null;
        //                 return {color: 'red1'};
        //             } 
        //         },
        //       },
        {
            headerName: "Total Mints",
            unSortIcon: true,
            field: "totalMints",
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            }
        }
    ]);
    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([
        {
            headerName: "Collection",
            cellRenderer: DeltaIndicator
        },
        {
            headerName: "Chain",
            // unSortIcon: true,
            cellRenderer: chainHandle,
            filter: false,
            cellClass: [
                "toshortimage"
            ]
        },
        {
            headerName: "Minting Price",
            // unSortIcon: true,
            cellRenderer: mintprice,
            filter: false,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage"
            ]
        },
        // {headerName: 'Minting Price',unSortIcon: true,shorting:true, field: 'price',cellStyle: function(params:any) {
        //             if (params.node.sixHourMint=='Police') {
        //                 return {color: 'red1'};
        //             } else {
        //                 // return null;
        //                 return {color: 'red1'};
        //             } 
        //         },
        //       },
        {
            headerName: "6 H Mints",
            unSortIcon: true,
            field: "sixHourCount",
            cellRenderer: sixHourCount,
            cellClass: [
                "toshortimage"
            ]
        },
        {
            headerName: "1 H Mints",
            unSortIcon: true,
            field: "oneHourCount",
            cellRenderer: twinty4mintHandle,
            cellStyle: function(params) {
                if (params.node.oneHourCount == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage",
                "toshortimage1"
            ]
        }
    ]);
    // Each Column Definition results in one Column.
    const [columnDefs1, setColumnDefs1] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([
        {
            headerName: "Collection",
            cellRenderer: DeltaIndicator
        },
        {
            headerName: "Chain",
            // unSortIcon: true,
            cellRenderer: chainHandle,
            filter: false,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage"
            ]
        },
        {
            headerName: "Floor Price",
            // unSortIcon: true,
            cellRenderer: fprice,
            filter: false,
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage"
            ]
        },
        {
            headerName: "24h Volume",
            unSortIcon: true,
            field: "h24v",
            cellStyle: function(params) {
                if (params.node.sixHourMint == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            }
        },
        {
            headerName: "24H Sale",
            unSortIcon: true,
            field: "h24s",
            cellRenderer: h24v,
            cellStyle: function(params) {
                if (params.node.oneHourCount == "Police") {
                    return {
                        color: "red1"
                    };
                } else {
                    // return null;
                    return {
                        color: "red1"
                    };
                }
            },
            cellClass: [
                "toshortimage",
                "toshortimage1"
            ]
        }
    ]);
    // DefaultColDef sets props common to all Columns
    //@ts-ignore
    const defaultColDef = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>({
            sortable: true
        }));
    // Example of consuming Grid Event
    const cellClickedListener = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)((event)=>{
    // console.log('cellClicked', event);
    }, []);
    // Example using Grid's API
    const buttonListener = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)((e)=>{
        //@ts-ignore
        gridRef.current.api.deselectAll();
    }, []);
    const containerStyle = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>({
            width: "100%",
            height: "100%"
        }), []);
    const gridStyle = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>({
            height: "100%",
            width: "100%"
        }), []);
    const autoSizeStrategy = (0,react__WEBPACK_IMPORTED_MODULE_10__.useMemo)(()=>{
        return {
            type: "fitGridWidth"
        };
    }, []);
    const onGridSizeChanged = (0,react__WEBPACK_IMPORTED_MODULE_10__.useCallback)((params)=>{
        // get the current grids width
        //@ts-ignore
        var gridWidth = document.getElementById("grid-wrapper").offsetWidth;
        // keep track of which columns to hide/show
        var columnsToShow = [];
        var columnsToHide = [];
        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        var totalColsWidth = 0;
        var allColumns = params.api.getColumns();
        if (allColumns && allColumns.length > 0) {
            for(var i = 0; i < allColumns.length; i++){
                var column = allColumns[i];
                totalColsWidth += column.getMinWidth() || 0;
                if (totalColsWidth > gridWidth) {
                    columnsToHide.push(column.getColId());
                } else {
                    columnsToShow.push(column.getColId());
                }
            }
        }
        // show/hide columns based on current grid width
        params.api.setColumnsVisible(columnsToShow, true);
        params.api.setColumnsVisible(columnsToHide, false);
        // fill out any available space to ensure there are no gaps
        params.api.sizeColumnsToFit();
    }, []);
    const [myCar, setMyCar] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("all");
    const handleChange = (event)=>{
        setMyCar(event.target.value);
        // console.log(event.target.value, myCarChain);
        // rowDataold
        if ("all" == event.target.value) {
            setRowData(rowDataold);
            return;
        }
        let newarray = [];
        if (myCarChain == "all" || !myCarChain) {
            for(let index = 0; index < rowDataold.length; index++){
                const element = rowDataold[index];
                // console.log(element);
                if ((element === null || element === void 0 ? void 0 : element.mintType) == event.target.value) {
                    newarray.push(element);
                }
            }
        } else {
            for(let index1 = 0; index1 < rowDataold.length; index1++){
                const element1 = rowDataold[index1];
                // console.log(element);
                if ((element1 === null || element1 === void 0 ? void 0 : element1.chain) == myCarChain && (element1 === null || element1 === void 0 ? void 0 : element1.mintType) == event.target.value) {
                    newarray.push(element1);
                }
            }
        }
        setRowData(newarray);
    };
    const handleChangeChain = (event)=>{
        let vts = Number(event.target.value);
        // console.log(vts);
        setMyCarChain(vts);
        // console.log('vsts',InternalurlMain[vts]);
        // console.log('supabase',countries?.[0]?.[InternalurlMain[vts]]);
        // setVersion(countries?.[0]?.[InternalurlMain[vts]]);
        if ("all" == event.target.value) {
            setRowData(rowDataold);
            return;
        }
        let newarray = [];
        if (myCar == "all" || !myCar) {
            for(let index = 0; index < rowDataold.length; index++){
                const element = rowDataold[index];
                // console.log(element);
                if ((element === null || element === void 0 ? void 0 : element.chain) == event.target.value) {
                    newarray.push(element);
                }
            }
        } else {
            for(let index1 = 0; index1 < rowDataold.length; index1++){
                const element1 = rowDataold[index1];
                // console.log(element);
                if ((element1 === null || element1 === void 0 ? void 0 : element1.chain) == event.target.value && (element1 === null || element1 === void 0 ? void 0 : element1.mintType) == myCar) {
                    newarray.push(element1);
                }
            }
        }
        setRowData(newarray);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "imagebg",
                src: "../bvinvibg1.png",
                width: "1000",
                height: 500,
                alt: "sdf"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        css: {
                            pt: "$2",
                            mb: "$4",
                            mt: "$5",
                            display: "grid",
                            gap: "$4",
                            gridTemplateColumns: "repeat(1, 1fr)",
                            "@sm": {
                                gridTemplateColumns: "repeat(2, 1fr)"
                            },
                            "@lg": {
                                gridTemplateColumns: "repeat(4, 1fr)"
                            }
                        },
                        children: toshow && //@ts-ignore
                        toshow.slice(0, 4).map((collection, i)=>{
                            var _collection_recentSales, _collection_recentSales_i, _collection_recentSales_i_token, _collection_recentSales1, _collection_recentSales_i1, _collection_recentSales_i_token1, _collection_recentSales_i_token_image, _collection_recentSales2, _collection_recentSales_i2, _collection_recentSales_i_token2;
                            var //@ts-ignore
                            _collection_image, _collection_image1;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_18___default()), {
                                href: InternalurlMain[collection === null || collection === void 0 ? void 0 : collection.chain] + "/collection/" + (collection === null || collection === void 0 ? void 0 : collection.address),
                                style: {
                                    display: "grid"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    direction: "column",
                                    css: {
                                        flex: 1,
                                        width: "100%",
                                        borderRadius: 12,
                                        cursor: "pointer",
                                        height: "100%",
                                        background: "$neutralBgSubtle",
                                        $$shadowColor: "$colors$panelShadow",
                                        boxShadow: "0 0px 12px 0px $$shadowColor",
                                        overflow: "hidden",
                                        position: "relative",
                                        p: "$3",
                                        "&:hover > div > div> img:nth-child(1)": {
                                            transform: "scale(1.075)"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                        direction: "column",
                                        css: {
                                            zIndex: 2,
                                            position: "relative",
                                            flex: 1,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                css: {
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    borderRadius: 8
                                                },
                                                children: ((_collection_image = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image !== void 0 ? _collection_image : (_collection_recentSales = collection.recentSales) === null || _collection_recentSales === void 0 ? void 0 : (_collection_recentSales_i = _collection_recentSales[i]) === null || _collection_recentSales_i === void 0 ? void 0 : (_collection_recentSales_i_token = _collection_recentSales_i.token) === null || _collection_recentSales_i_token === void 0 ? void 0 : _collection_recentSales_i_token.image) || ((_collection_recentSales1 = collection.recentSales) === null || _collection_recentSales1 === void 0 ? void 0 : (_collection_recentSales_i1 = _collection_recentSales1[i]) === null || _collection_recentSales_i1 === void 0 ? void 0 : (_collection_recentSales_i_token1 = _collection_recentSales_i1.token) === null || _collection_recentSales_i_token1 === void 0 ? void 0 : (_collection_recentSales_i_token_image = _collection_recentSales_i_token1.image) === null || _collection_recentSales_i_token_image === void 0 ? void 0 : _collection_recentSales_i_token_image.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (_collection_image1 = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image1 !== void 0 ? _collection_image1 : (_collection_recentSales2 = collection.recentSales) === null || _collection_recentSales2 === void 0 ? void 0 : (_collection_recentSales_i2 = _collection_recentSales2[i]) === null || _collection_recentSales_i2 === void 0 ? void 0 : (_collection_recentSales_i_token2 = _collection_recentSales_i2.token) === null || _collection_recentSales_i_token2 === void 0 ? void 0 : _collection_recentSales_i_token2.image,
                                                    style: {
                                                        transition: "transform 300ms ease-in-out",
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        objectFit: "cover"
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                    css: {
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        background: "$gray3"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                css: {
                                                    my: "$4",
                                                    mb: "$2"
                                                },
                                                justify: "between",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                    style: "h5",
                                                    as: "h5",
                                                    ellipsify: true,
                                                    css: {
                                                        flex: 1
                                                    },
                                                    children: //@ts-ignore
                                                    collection === null || collection === void 0 ? void 0 : collection.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                direction: "column",
                                                css: {
                                                    flex: 1,
                                                    width: "100%",
                                                    borderRadius: 12,
                                                    cursor: "pointer",
                                                    height: "100%",
                                                    background: "$neutralBgSubtle",
                                                    $$shadowColor: "$colors$panelShadow",
                                                    boxShadow: "0 0px 12px 0px $$shadowColor",
                                                    overflow: "hidden",
                                                    position: "relative",
                                                    p: ""
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                    direction: "column",
                                                    css: {
                                                        zIndex: 2,
                                                        position: "relative",
                                                        flex: 1,
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                        css: {
                                                            fontSize: "14px"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                            css: {
                                                                mr: "$5"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    style: "subtitle2",
                                                                    color: "subtle",
                                                                    children: "Mint Price"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                    css: {
                                                                        mt: 2,
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                            css: {
                                                                                width: "14px",
                                                                                height: "14px",
                                                                                marginTop: "7px"
                                                                            },
                                                                            src: "../../../" + imagesMain[collection === null || collection === void 0 ? void 0 : collection.chain],
                                                                            alt: "chain",
                                                                            width: 14,
                                                                            height: 14
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                            style: "h4",
                                                                            as: "h4",
                                                                            css: {
                                                                                mt: 2,
                                                                                fontSize: "16px"
                                                                            },
                                                                            children: [
                                                                                collection === null || collection === void 0 ? void 0 : collection.price,
                                                                                " ",
                                                                                collection === null || collection === void 0 ? void 0 : collection.symbol
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, collection === null || collection === void 0 ? void 0 : collection.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        className: "againbox",
                        direction: "column",
                        css: {
                            px: "0",
                            p: 0,
                            display: "flow",
                            "@sm": {
                                px: "$1 $5"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            children: "Trending Drops  "
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: containerStyle,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                id: "grid-wrapper",
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: gridStyle,
                                        className: theme == "light" ? "ag-theme-alpine example-wrapper hide" : "ag-theme-alpine-dark example-wrapper hide",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ag_grid_react__WEBPACK_IMPORTED_MODULE_4__.AgGridReact, {
                                            //@ts-ignore
                                            ref: gridRef,
                                            rowData: rowData,
                                            columnDefs: columnDefs,
                                            defaultColDef: defaultColDef,
                                            animateRows: true,
                                            rowSelection: "multiple" // Options - allows click selection of rows
                                            ,
                                            onCellClicked: cellClickedListener,
                                            enableCellChangeFlash: true,
                                            //@ts-ignore
                                            // autoSizeStrategy={autoSizeStrategy}
                                            // onGridSizeChanged={onGridSizeChanged}
                                            domLayout: "autoHeight"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: gridStyle,
                                        className: theme == "light" ? "ag-theme-alpine example-wrapper show" : "ag-theme-alpine-dark example-wrapper show",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ag_grid_react__WEBPACK_IMPORTED_MODULE_4__.AgGridReact, {
                                            //@ts-ignore
                                            ref: gridRef,
                                            rowData: rowData,
                                            columnDefs: columnDefs,
                                            defaultColDef: defaultColDef,
                                            animateRows: true,
                                            rowSelection: "multiple" // Options - allows click selection of rows
                                            ,
                                            onCellClicked: cellClickedListener,
                                            enableCellChangeFlash: true,
                                            //@ts-ignore
                                            autoSizeStrategy: autoSizeStrategy,
                                            onGridSizeChanged: onGridSizeChanged,
                                            domLayout: "autoHeight"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                            justify: "between",
                            align: "center",
                            css: {
                                flexWrap: "wrap",
                                mb: "$4",
                                gap: "$3"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                pt: "$2",
                                mb: "$4",
                                display: "grid",
                                gap: "$4",
                                gridTemplateColumns: "repeat(1, 1fr)",
                                "@sm": {
                                    gridTemplateColumns: "repeat(2, 1fr)"
                                },
                                "@lg": {
                                    gridTemplateColumns: "repeat(4, 1fr)"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        className: "againbox",
                        direction: "column",
                        css: {
                            px: "0",
                            p: 0,
                            display: "flow",
                            "@sm": {
                                px: "$1 $5"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            children: "Trending Collections  "
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: containerStyle,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                id: "grid-wrapper",
                                style: {
                                    width: "100%",
                                    height: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: gridStyle,
                                        className: theme == "light" ? "ag-theme-alpine example-wrapper hide" : "ag-theme-alpine-dark example-wrapper hide",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ag_grid_react__WEBPACK_IMPORTED_MODULE_4__.AgGridReact, {
                                            //@ts-ignore
                                            ref: gridRef,
                                            rowData: fc,
                                            columnDefs: columnDefs1,
                                            defaultColDef: defaultColDef,
                                            animateRows: true,
                                            rowSelection: "multiple" // Options - allows click selection of rows
                                            ,
                                            onCellClicked: cellClickedListener,
                                            enableCellChangeFlash: true,
                                            //@ts-ignore
                                            // autoSizeStrategy={autoSizeStrategy}
                                            // onGridSizeChanged={onGridSizeChanged}
                                            domLayout: "autoHeight"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: gridStyle,
                                        className: theme == "light" ? "ag-theme-alpine example-wrapper show" : "ag-theme-alpine-dark example-wrapper show",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ag_grid_react__WEBPACK_IMPORTED_MODULE_4__.AgGridReact, {
                                            //@ts-ignore
                                            ref: gridRef,
                                            rowData: fc,
                                            columnDefs: columnDefs1,
                                            defaultColDef: defaultColDef,
                                            animateRows: true,
                                            rowSelection: "multiple" // Options - allows click selection of rows
                                            ,
                                            onCellClicked: cellClickedListener,
                                            enableCellChangeFlash: true,
                                            //@ts-ignore
                                            autoSizeStrategy: autoSizeStrategy,
                                            onGridSizeChanged: onGridSizeChanged,
                                            domLayout: "autoHeight"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                            justify: "between",
                            align: "center",
                            css: {
                                flexWrap: "wrap",
                                mb: "$4",
                                gap: "$3"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            css: {
                                pt: "$2",
                                mb: "$4",
                                display: "grid",
                                gap: "$4",
                                gridTemplateColumns: "repeat(1, 1fr)",
                                "@sm": {
                                    gridTemplateColumns: "repeat(2, 1fr)"
                                },
                                "@lg": {
                                    gridTemplateColumns: "repeat(4, 1fr)"
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        className: "againbox",
                        direction: "column",
                        css: {
                            px: "0",
                            p: 0,
                            display: "flow",
                            "@sm": {
                                px: "$1 $5"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            children: "Featured Drops"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        css: {
                            pt: "$2",
                            mb: "$4",
                            mt: "$5",
                            display: "grid",
                            gap: "$4",
                            gridTemplateColumns: "repeat(1, 1fr)",
                            "@sm": {
                                gridTemplateColumns: "repeat(2, 1fr)"
                            },
                            "@lg": {
                                gridTemplateColumns: "repeat(4, 1fr)"
                            }
                        },
                        children: featureddrops && //@ts-ignore
                        featureddrops.slice(0, 4).map((collection, i)=>{
                            var _collection_recentSales, _collection_recentSales_i, _collection_recentSales_i_token, _collection_recentSales1, _collection_recentSales_i1, _collection_recentSales_i_token1, _collection_recentSales_i_token_image, _collection_recentSales2, _collection_recentSales_i2, _collection_recentSales_i_token2;
                            var //@ts-ignore
                            _collection_image, _collection_image1;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_18___default()), {
                                href: InternalurlMain[collection === null || collection === void 0 ? void 0 : collection.chain] + "/collection/" + (collection === null || collection === void 0 ? void 0 : collection.address),
                                style: {
                                    display: "grid"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    direction: "column",
                                    css: {
                                        flex: 1,
                                        width: "100%",
                                        borderRadius: 12,
                                        cursor: "pointer",
                                        height: "100%",
                                        background: "$neutralBgSubtle",
                                        $$shadowColor: "$colors$panelShadow",
                                        boxShadow: "0 0px 12px 0px $$shadowColor",
                                        overflow: "hidden",
                                        position: "relative",
                                        p: "$3",
                                        "&:hover > div > div> img:nth-child(1)": {
                                            transform: "scale(1.075)"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                        direction: "column",
                                        css: {
                                            zIndex: 2,
                                            position: "relative",
                                            flex: 1,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                css: {
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    borderRadius: 8
                                                },
                                                children: ((_collection_image = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image !== void 0 ? _collection_image : (_collection_recentSales = collection.recentSales) === null || _collection_recentSales === void 0 ? void 0 : (_collection_recentSales_i = _collection_recentSales[i]) === null || _collection_recentSales_i === void 0 ? void 0 : (_collection_recentSales_i_token = _collection_recentSales_i.token) === null || _collection_recentSales_i_token === void 0 ? void 0 : _collection_recentSales_i_token.image) || ((_collection_recentSales1 = collection.recentSales) === null || _collection_recentSales1 === void 0 ? void 0 : (_collection_recentSales_i1 = _collection_recentSales1[i]) === null || _collection_recentSales_i1 === void 0 ? void 0 : (_collection_recentSales_i_token1 = _collection_recentSales_i1.token) === null || _collection_recentSales_i_token1 === void 0 ? void 0 : (_collection_recentSales_i_token_image = _collection_recentSales_i_token1.image) === null || _collection_recentSales_i_token_image === void 0 ? void 0 : _collection_recentSales_i_token_image.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (_collection_image1 = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image1 !== void 0 ? _collection_image1 : (_collection_recentSales2 = collection.recentSales) === null || _collection_recentSales2 === void 0 ? void 0 : (_collection_recentSales_i2 = _collection_recentSales2[i]) === null || _collection_recentSales_i2 === void 0 ? void 0 : (_collection_recentSales_i_token2 = _collection_recentSales_i2.token) === null || _collection_recentSales_i_token2 === void 0 ? void 0 : _collection_recentSales_i_token2.image,
                                                    style: {
                                                        transition: "transform 300ms ease-in-out",
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        objectFit: "cover"
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                    css: {
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        background: "$gray3"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                css: {
                                                    my: "$4",
                                                    mb: "$2"
                                                },
                                                justify: "between",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                    style: "h5",
                                                    as: "h5",
                                                    ellipsify: true,
                                                    css: {
                                                        flex: 1
                                                    },
                                                    children: //@ts-ignore
                                                    collection === null || collection === void 0 ? void 0 : collection.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                direction: "column",
                                                css: {
                                                    flex: 1,
                                                    width: "100%",
                                                    borderRadius: 12,
                                                    cursor: "pointer",
                                                    height: "100%",
                                                    background: "$neutralBgSubtle",
                                                    $$shadowColor: "$colors$panelShadow",
                                                    boxShadow: "0 0px 12px 0px $$shadowColor",
                                                    overflow: "hidden",
                                                    position: "relative",
                                                    p: ""
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                    direction: "column",
                                                    css: {
                                                        zIndex: 2,
                                                        position: "relative",
                                                        flex: 1,
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                        css: {
                                                            fontSize: "14px"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                            css: {
                                                                mr: "$5"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                    style: "subtitle2",
                                                                    color: "subtle",
                                                                    children: "Mint Price"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                    css: {
                                                                        mt: 2,
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                            css: {
                                                                                width: "14px",
                                                                                height: "14px",
                                                                                marginTop: "7px"
                                                                            },
                                                                            src: "../../../" + imagesMain[collection === null || collection === void 0 ? void 0 : collection.chain],
                                                                            alt: "chain",
                                                                            width: 14,
                                                                            height: 14
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                            style: "h4",
                                                                            as: "h4",
                                                                            css: {
                                                                                mt: 2,
                                                                                fontSize: "16px"
                                                                            },
                                                                            children: [
                                                                                collection === null || collection === void 0 ? void 0 : collection.price,
                                                                                " ",
                                                                                collection === null || collection === void 0 ? void 0 : collection.symbol
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, collection === null || collection === void 0 ? void 0 : collection.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        className: "againbox",
                        direction: "column",
                        css: {
                            px: "0",
                            p: 0,
                            display: "flow",
                            "@sm": {
                                px: "$1 $5"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                            children: "Featured collections"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    px: 24,
                    pb: 24,
                    height: "",
                    "@bp800": {
                        px: "$6"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    css: {
                        height: "100%",
                        "@bp800": {},
                        "@xl": {}
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        css: {
                            pt: "$2",
                            mb: "$4",
                            mt: "$5",
                            display: "grid",
                            gap: "$4",
                            gridTemplateColumns: "repeat(1, 1fr)",
                            "@sm": {
                                gridTemplateColumns: "repeat(2, 1fr)"
                            },
                            "@lg": {
                                gridTemplateColumns: "repeat(4, 1fr)"
                            }
                        },
                        children: featuredcollections && //@ts-ignore
                        featuredcollections.slice(0, 4).map((collection, i)=>{
                            var _collection_recentSales, _collection_recentSales_i, _collection_recentSales_i_token, _collection_recentSales1, _collection_recentSales_i1, _collection_recentSales_i_token1, _collection_recentSales_i_token_image, _collection_recentSales2, _collection_recentSales_i2, _collection_recentSales_i_token2;
                            var //@ts-ignore
                            _collection_image, _collection_image1;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_18___default()), {
                                href: InternalurlMain[collection === null || collection === void 0 ? void 0 : collection.chain] + "/collection/" + (collection === null || collection === void 0 ? void 0 : collection.address),
                                style: {
                                    display: "grid"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    direction: "column",
                                    css: {
                                        flex: 1,
                                        width: "100%",
                                        borderRadius: 12,
                                        cursor: "pointer",
                                        height: "100%",
                                        background: "$neutralBgSubtle",
                                        $$shadowColor: "$colors$panelShadow",
                                        boxShadow: "0 0px 12px 0px $$shadowColor",
                                        overflow: "hidden",
                                        position: "relative",
                                        p: "$3",
                                        "&:hover > div > div> img:nth-child(1)": {
                                            transform: "scale(1.075)"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                        direction: "column",
                                        css: {
                                            zIndex: 2,
                                            position: "relative",
                                            flex: 1,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                css: {
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    borderRadius: 8
                                                },
                                                children: ((_collection_image = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image !== void 0 ? _collection_image : (_collection_recentSales = collection.recentSales) === null || _collection_recentSales === void 0 ? void 0 : (_collection_recentSales_i = _collection_recentSales[i]) === null || _collection_recentSales_i === void 0 ? void 0 : (_collection_recentSales_i_token = _collection_recentSales_i.token) === null || _collection_recentSales_i_token === void 0 ? void 0 : _collection_recentSales_i_token.image) || ((_collection_recentSales1 = collection.recentSales) === null || _collection_recentSales1 === void 0 ? void 0 : (_collection_recentSales_i1 = _collection_recentSales1[i]) === null || _collection_recentSales_i1 === void 0 ? void 0 : (_collection_recentSales_i_token1 = _collection_recentSales_i1.token) === null || _collection_recentSales_i_token1 === void 0 ? void 0 : (_collection_recentSales_i_token_image = _collection_recentSales_i_token1.image) === null || _collection_recentSales_i_token_image === void 0 ? void 0 : _collection_recentSales_i_token_image.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    loading: "lazy",
                                                    src: (_collection_image1 = collection === null || collection === void 0 ? void 0 : collection.image) !== null && _collection_image1 !== void 0 ? _collection_image1 : (_collection_recentSales2 = collection.recentSales) === null || _collection_recentSales2 === void 0 ? void 0 : (_collection_recentSales_i2 = _collection_recentSales2[i]) === null || _collection_recentSales_i2 === void 0 ? void 0 : (_collection_recentSales_i_token2 = _collection_recentSales_i2.token) === null || _collection_recentSales_i_token2 === void 0 ? void 0 : _collection_recentSales_i_token2.image,
                                                    style: {
                                                        transition: "transform 300ms ease-in-out",
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        objectFit: "cover"
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                    css: {
                                                        width: "100%",
                                                        borderRadius: 8,
                                                        height: 250,
                                                        background: "$gray3"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                css: {
                                                    my: "$4",
                                                    mb: "$2"
                                                },
                                                justify: "between",
                                                align: "center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                    style: "h5",
                                                    as: "h5",
                                                    ellipsify: true,
                                                    css: {
                                                        flex: 1
                                                    },
                                                    children: //@ts-ignore
                                                    collection === null || collection === void 0 ? void 0 : collection.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                direction: "column",
                                                css: {
                                                    flex: 1,
                                                    width: "100%",
                                                    borderRadius: 12,
                                                    cursor: "pointer",
                                                    height: "100%",
                                                    background: "$neutralBgSubtle",
                                                    $$shadowColor: "$colors$panelShadow",
                                                    boxShadow: "0 0px 12px 0px $$shadowColor",
                                                    overflow: "hidden",
                                                    position: "relative",
                                                    p: ""
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                    direction: "column",
                                                    css: {
                                                        zIndex: 2,
                                                        position: "relative",
                                                        flex: 1,
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                                        css: {
                                                            fontSize: "14px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                css: {
                                                                    mr: "$5"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                        style: "subtitle2",
                                                                        color: "subtle",
                                                                        children: "Floor Price"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                        css: {
                                                                            mt: 2,
                                                                            display: "flex"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                css: {
                                                                                    width: "14px",
                                                                                    height: "14px",
                                                                                    marginTop: "7px"
                                                                                },
                                                                                src: "../../../" + imagesMain[collection === null || collection === void 0 ? void 0 : collection.chain],
                                                                                alt: "chain",
                                                                                width: 14,
                                                                                height: 14
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                                style: "h4",
                                                                                as: "h4",
                                                                                css: {
                                                                                    mt: 2,
                                                                                    fontSize: "16px"
                                                                                },
                                                                                children: [
                                                                                    collection === null || collection === void 0 ? void 0 : collection.price,
                                                                                    " ",
                                                                                    collection === null || collection === void 0 ? void 0 : collection.symbol
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                                                                css: {
                                                                    mr: "$4"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                        style: "subtitle2",
                                                                        color: "subtle",
                                                                        children: "24H Volume"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                                                                        style: "h4",
                                                                        as: "h4",
                                                                        css: {
                                                                            mt: 2,
                                                                            fontSize: "14px"
                                                                        },
                                                                        children: collection === null || collection === void 0 ? void 0 : collection.h24v
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }, collection === null || collection === void 0 ? void 0 : collection.id);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_Footer__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,7948,2239,2153,833,5235,3049,8053,2888,179], function() { return __webpack_exec__(655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);